import { Component, EventEmitter, OnInit, Output, Input, ViewChild, ElementRef } from '@angular/core';
import { AutoUnsubscribe } from '../../../../core/decorators/auto-unsubscribe';

@Component({
    selector: 'app-generic-modal',
    templateUrl: './generic-modal.component.html',
    styleUrls: ['./generic-modal.component.scss']
})

@AutoUnsubscribe()
export class GenericModalComponent implements OnInit {
    
    @Output() modalClose = new EventEmitter<any>();
    error: string;
    code: string;

    @Input() title: string;
    @Input() message: string;
    @Input() textButtonOk: string;
    @Input() textButtonCancel: string;

    @Input() aspa: boolean;
    @Input() isButtonOk: boolean;
    @Input() isButtonCancel: boolean;
    @Input() popupName?: string;
    @Input() isIconOk?: boolean;
    @Input() isIconCancel?: boolean;

    @ViewChild('focus', { static: false }) inputElement: ElementRef;

    constructor() { }

    ngOnInit() { 
        setTimeout(()=>{
            if(this.inputElement){
                this.inputElement.nativeElement.focus();
            }
        }, 10); 
    }

    closeModal(datos) {
        const params = {
            nombrePopup: this.popupName,
            datosPopup: datos
        }
        this.modalClose.emit(params);
    }

}
